import BulkToggleControls from '../../generic/BulkToggleControls';
import { changeQuoteLineSelection } from '../actions';
import { connectEditor } from '../connect-editor';

export default connectEditor(
  ({ quoteLinesById, quoteLinesSelection }) => {
    const entities = Object.values(quoteLinesById)
      .filter(quote => !quote.filteredOut)
      .map(item => item.id);
    const activeEntities = entities.filter(id => quoteLinesSelection[id]);
    return { entities, activeEntities };
  },
  { setSelected: changeQuoteLineSelection },
  ({ activeEntities, entities }, { setSelected }) => ({
    activeEntities,
    entities,
    onToggleAll: value => entities.forEach(id => setSelected(id, value)),
  }),
)(BulkToggleControls);
